import { axiosInstance } from '@/services/axios-instance';
import {
  IAnswerHomeworkParams,
  IE12HomeworkResponse,
  IHomeworkResponse,
  IHomeworksParams,
  IE12HomeworkDetailResponse,
  IQuestionAnswerPayload,
} from '@/services/homeworks/types';
import { GUID, IPageResponse } from '@/types/common.types';

export const getHomeworkAssigmentById = async (
  assigmentID: string
): Promise<IHomeworkResponse> => {
  return axiosInstance.get(`/homework-assignments/${assigmentID}`);
};
export const answerHomework = async ({
  assigmentID,
  ...data
}: IAnswerHomeworkParams): Promise<IHomeworkResponse> => {
  return axiosInstance.put(`/homework-assignments/${assigmentID}/answer`, data);
};

export const getHomeworks = async (
  params: IHomeworksParams
): Promise<IPageResponse<IHomeworkResponse>> => {
  return axiosInstance.get('/homework-assignments', { params });
};

export const getE12Homeworks = async (
  params: IHomeworksParams
): Promise<IPageResponse<IE12HomeworkResponse>> => {
  return axiosInstance.get('/e12-homework-assignments', { params });
};

export const getE12HomeworkById = async (
  homeworkId: string
): Promise<IE12HomeworkDetailResponse> => {
  return axiosInstance.get(`/e12-homework-assignments/${homeworkId}`);
};

export const watchE12HomeworkVideo = async (
  assignmentId: string,
  e12HomeworkVideoID: GUID
): Promise<void> => {
  return axiosInstance.put(
    `/e12-homework-assignments/${assignmentId}/video-watch`,
    {
      e12HomeworkVideoID,
    }
  );
};

export const answerE12HomeworkQuestion = async (
  homeworkId: string,
  data: IQuestionAnswerPayload
): Promise<void> => {
  return axiosInstance.put(
    `/e12-homework-assignments/${homeworkId}/question-answer`,
    data
  );
};

export const submitE12Homework = async (
  assignmentId: string
): Promise<void> => {
  return axiosInstance.post(
    `/e12-homework-assignments/${assignmentId}/submit-homework`
  );
};
